import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

/**
 * Custom entity content extensions for tabs not covered by alpha plugins.
 * - CI/CD tab for service components
 * - API tab for service components
 * - Dependencies tab for service/website components
 * - System Diagram tab for system entities
 */
export const entityContentModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    // CI/CD tab for service components
    EntityContentBlueprint.make({
      name: 'cicd',
      params: {
        path: '/ci-cd',
        title: 'CI/CD',
        filter: 'kind:component,spec.type:service',
        loader: () =>
          import('../components/catalog/entityContent/CiCdContent').then(m => (
            <m.CiCdContent />
          )),
      },
    }),

    // API tab for service components
    EntityContentBlueprint.make({
      name: 'api-dependencies',
      params: {
        path: '/api',
        title: 'API',
        filter: 'kind:component,spec.type:service',
        loader: () =>
          import('../components/catalog/entityContent/ApiContent').then(m => (
            <m.ApiContent />
          )),
      },
    }),

    // Dependencies tab for service and website components
    EntityContentBlueprint.make({
      name: 'dependencies',
      params: {
        path: '/dependencies',
        title: 'Dependencies',
        filter: 'kind:component',
        loader: () =>
          import(
            '../components/catalog/entityContent/DependenciesContent'
          ).then(m => <m.DependenciesContent />),
      },
    }),

    // System Diagram tab for system entities
    EntityContentBlueprint.make({
      name: 'system-diagram',
      params: {
        path: '/diagram',
        title: 'Diagram',
        filter: 'kind:system',
        loader: () =>
          import(
            '../components/catalog/entityContent/SystemDiagramContent'
          ).then(m => <m.SystemDiagramContent />),
      },
    }),
  ],
});
